export const defaultGroups = [
    {
        name: '花、番子',
        options: [
            { name: '無花', value: 1, desc: '手牌內沒有任何花牌（春夏秋冬、梅蘭菊竹）', isSelected: false, quantity: 1 },
            { name: '正花', value: 2, desc: '花牌與自己門風相同（例如東家有春、南家有夏）', isSelected: false, quantity: 1 },
            { name: '爛花', value: 1, desc: '花牌與自己門風不同（不屬於正花）', isSelected: false, quantity: 1 },
            { name: '東、南、西、北', value: 1, desc: '刻子或槓子為自己門風或圈風（風牌番）', isSelected: false, quantity: 1 },
            { name: '三元牌', value: 2, desc: '刻子或槓子為中、發、白（三元牌）', isSelected: false, quantity: 1 },
            { name: '槓', value: 1, desc: '明槓：由碰後或他人打出第四隻組成槓子', isSelected: false, quantity: 1 },
            { name: '暗槓', value: 2, desc: '暗槓：自己手中已有四隻相同牌組成槓子', isSelected: false, quantity: 1 },
        ],
    },
    {
        name: '特別獎勵',
        options: [
            { name: '聽牌', value: 5, desc: '聲明已經叫胡，不得轉章，可以睇其他家的牌', isSelected: false, quantity: 1 },
            { name: '雞胡', value: 10, desc: '胡出時(不計莊前)只得一番;食一筒或四筒都是雞胡。如果自摸或已叫了聽牌就一定不是雞胡了：', isSelected: false, quantity: 1, image: 'chicken.png' },
            { name: '對碰', value: 1, desc: '在下列例子，對碰四萬及發財：', isSelected: false, quantity: 1, image: '對碰.png' },
            { name: '假獨', value: 1, desc: '可以砌到叫單釣或叫偏章; 在下列例子，食一筒就是假獨，四筒就不是假獨：', isSelected: false, quantity: 1, image: '假獨.png' },
            { name: '獨獨', value: 2, desc: '單釣或叫偏章', isSelected: false, quantity: 1, image: '獨獨.png' },
            { name: '平胡', value: 3, desc: '全副牌由順子組成，沒有刻子，且無番子（可有花）', isSelected: false, quantity: 1, image: '平胡.png' },
            { name: '將眼', value: 1, desc: '以一對二、五或八做眼', isSelected: false, quantity: 1, image: '將眼.png' },
            { name: '老少', value: 2, desc: '同門一,二,三 加七,八,九 或 一,一,一 加九,九,九 (有 同門牌亦可)', isSelected: false, quantity: 1 },
            { name: '無字', value: 1, desc: '沒有番子', isSelected: false, quantity: 1 },
            { name: '無字花', value: 5, desc: '沒有番子及沒有花', isSelected: false, quantity: 1 },
            { name: '無字花平胡(大平糊)', value: 10, desc: '沒有番子，沒有花，又是平胡', isSelected: false, quantity: 1 },
            { name: '門清', value: 3, desc: '門前清, 暗槓亦可', isSelected: false, quantity: 1 },
            { name: '海底撈月', value: 20, desc: '摸到最後一隻牌（海底牌）自摸食胡', isSelected: false, quantity: 1 },
            { name: '自摸', value: 1, desc: '自己摸牌成胡，不是食他人出沖', isSelected: false, quantity: 1 },
            { name: '門清自摸', value: 5, desc: '門前清自摸', isSelected: false, quantity: 1 },
        ],
    },
    {
        name: '食胡',
        options: [
            { name: '花上食胡', value: 1, desc: '補花後摸牌或食出而成胡', isSelected: false, quantity: 1 },
            { name: '槓上食胡', value: 1, desc: '開槓後補牌（槓尾牌）成胡', isSelected: false, quantity: 1 },
            { name: '搶槓食胡', value: 1, desc: '搶槓不當自摸，搶槓只當是被搶那家出沖，不過加一番', isSelected: false, quantity: 1 },
            { name: '槓上槓食胡', value: 30, desc: '開槓補牌後再開槓，再補牌成胡（連續槓後胡）', isSelected: false, quantity: 1 },
            { name: '搶槓上槓食胡', value: 30, desc: '也是不當自摸，當槓上槓的那家出沖，加三十番', isSelected: false, quantity: 1 },
        ],
    },
    {
        name: '暗刻',
        options: [
            { name: '二暗刻', value: 3, desc: '刻子就是三隻一樣的牌。明槓、暗槓 or 在自己手上三隻一樣的牌叫做暗刻', isSelected: false, quantity: 1, image: '二暗刻.png' },
            { name: '三暗刻', value: 10, desc: '刻子就是三隻一樣的牌。明槓、暗槓 or 在自己手上三隻一樣的牌叫做暗刻', isSelected: false, quantity: 1 },
            { name: '四暗刻', value: 30, desc: '刻子就是三隻一樣的牌。明槓、暗槓 or 在自己手上三隻一樣的牌叫做暗刻', isSelected: false, quantity: 1 },
            { name: '五暗刻', value: 80, desc: '刻子就是三隻一樣的牌。明槓、暗槓 or 在自己手上三隻一樣的牌叫做暗刻', isSelected: false, quantity: 1 },
        ],
    },
    {
        name: '般高',
        options: [
            { name: '間間胡', value: 100, desc: '未有解釋住，等多陣', isSelected: false, quantity: 1 },
            { name: '一般高', value: 3, desc: '兩個一樣的順子', isSelected: false, quantity: 1, image: '一般高.png' },
            { name: '三般高', value: 15, desc: '三個一樣的順子', isSelected: false, quantity: 1, image: '三般高.png' },
            { name: '四般高', value: 30, desc: '四個一樣的順子', isSelected: false, quantity: 1, image: '四般高.png' },
        ],
    },
    {
        name: '相逢',
        options: [
            { name: '二相逢(順子)', value: 2, desc: '二個款式不同的但數字一樣順子', isSelected: false, quantity: 1, image: '二相逢.png' },
            { name: '三相逢(順子)', value: 10, desc: '三個款式不同的但數字一樣順子', isSelected: false, quantity: 1, image: '三相逢.png' },
            { name: '四同順', value: 20, desc: '四個數字一樣順子，不論款式，不再計三相逢/一般高/兩 般高/三般高', isSelected: false, quantity: 1, image: '四同順.png' },
            { name: '五同順', value: 40, desc: '五個數字一樣順子，不論款式，不再計三相逢/一般高/兩 般高/三般高', isSelected: false, quantity: 1, image: '五同順.png' },
        ],
    },
    {
        name: '兄弟姊妹',
        options: [
            { name: '二兄弟(刻子)', value: 3, desc: '兩款數字一樣的刻子', isSelected: false, quantity: 1, image: '二兄弟.png' },
            { name: '小三兄弟(刻子)', value: 10, desc: '二兄弟再加上另一個兄弟做眼', isSelected: false, quantity: 1, image: '小三兄弟.png' },
            { name: '大三兄弟(刻子)', value: 15, desc: '三款數字一樣的刻子', isSelected: false, quantity: 1, image: '大三兄弟.png' },
            { name: '二姊妹', value: 3, desc: '兩副同款而數子相連樣的刻子', isSelected: false, quantity: 1, image: '二姊妹.png' },
            { name: '小三姊妹', value: 8, desc: '兩副同款而數子相連樣的刻子，另加一對數子相連的眼', isSelected: false, quantity: 1, image: '小三姊妹.png' },
            { name: '三姊妹', value: 15, desc: '三副同款而數子相連樣的刻子', isSelected: false, quantity: 1, image: '三姊妹.png' },
            { name: '小四姊妹', value: 20, desc: '三副同款而數子相連樣的刻子，另加一對數子相連的眼', isSelected: false, quantity: 1, image: '小四姊妹.png' },
            { name: '四姊妹', value: 40, desc: '四副同款而數子相連樣的刻子', isSelected: false, quantity: 1, image: '四姊妹.png' },
            { name: '小五姊妹', value: 60, desc: '四副同款而數子相連樣的刻子，另加一對數子相連的眼', isSelected: false, quantity: 1, image: '小五姊妹.png' },
            { name: '五姊妹', value: 80, desc: '五副同款而數子相連樣的刻子', isSelected: false, quantity: 1, image: '五姊妹.png' },
        ],
    },
    {
        name: '基本野',
        options: [
            { name: '四歸一', value: 5, desc: '用盡同一隻牌的四隻牌', isSelected: false, quantity: 1, image: '四歸一.png' },
            { name: '四歸二', value: 10, desc: '用盡同一隻牌的四隻牌, 兩隻做眼', isSelected: false, quantity: 1, image: '四歸二.png' },
            { name: '四歸四', value: 20, desc: '用盡同一隻牌的四隻牌（順子）', isSelected: false, quantity: 1, image: '四歸四.png' },
            { name: '明龍', value: 10, desc: '同一個款式，只有一至九，其中有些是上回來的', isSelected: false, quantity: 1, image: '明龍.png' },
            { name: '暗龍', value: 20, desc: '同一個款式，只有一至九，全部是是手 裡的，食胡那隻可以是其他家打出', isSelected: false, quantity: 1 },
            { name: '明雜龍', value: 8, desc: '同一個款式，只有一至九，其中有些是上回來的', isSelected: false, quantity: 1, image: '明雜龍.png' },
            { name: '暗雜龍', value: 15, desc: '同一個款式，只有一至九，全部是是手 裡的，食胡那隻可以是其他家打出', isSelected: false, quantity: 1 },
            { name: '五門齊', value: 10, desc: '東南西北為一門，中發白為一門，筒索萬各三門。全副牌五門都有齊', isSelected: false, quantity: 1, image: '五門齊.png' },
            { name: '缺一門', value: 5, desc: '不計番子而缺少筒、索或萬一門', isSelected: false, quantity: 1, image: '缺一門.png' },
            { name: '混一色', value: 30, desc: '全副牌由同一花色牌加番子組成', isSelected: false, quantity: 1 },
            { name: '清一色', value: 80, desc: '全副牌只由同一花色牌組成，沒有番子', isSelected: false, quantity: 1 },
            { name: '對對胡', value: 30, desc: '全副牌由刻子（或槓子）組成，沒有順子', isSelected: false, quantity: 1 },
        ],
    },
    {
        name: 'CLS',
        options: [
            { name: '全求人', value: 15, desc: '全副牌落地，單釣而其他家打出胡牌(明 槓亦可)', isSelected: false, quantity: 1 },
            { name: '半求人', value: 8, desc: '全副牌落地，單釣而自摸(明 槓亦可)', isSelected: false, quantity: 1 },
            { name: '七只內', value: 20, desc: '地下只有七隻牌內食胡(算 至第七隻)，不計上及碰了的牌', isSelected: false, quantity: 1 },
            { name: '十只內', value: 10, desc: '地下只有十隻牌內食胡(算至第十隻)，不計上及碰了的牌', isSelected: false, quantity: 1 },
            { name: '小三元', value: 20, desc: '中、發、白其中兩組為刻子，另一組為眼', isSelected: false, quantity: 1 },
            { name: '大三元', value: 40, desc: '中、發、白三組皆為刻子 or 槓子', isSelected: false, quantity: 1 },
            { name: '小三風', value: 15, desc: '東南西北其中兩組為刻子，另一組為眼', isSelected: false, quantity: 1 },
            { name: '大三風', value: 30, desc: '東南西北三組皆為刻子 or 槓子', isSelected: false, quantity: 1 },
            { name: '小四喜', value: 60, desc: '東南西北三組為刻子，另一組為眼', isSelected: false, quantity: 1 },
            { name: '大四喜', value: 80, desc: '東南西北四組皆為刻子 or 槓子', isSelected: false, quantity: 1 },
            { name: '十三么', value: 80, desc: '十三么，另三隻是自己摸回來的順子 or 暗刻，不能上 or 碰回來', isSelected: false, quantity: 1, image: '十三么.png' },
            { name: '十六不搭 (九唔搭八)', value: 40, desc: '東南西北中發白，其他三門每樣三隻，但不能搭上，例如一、四、九 or 二、五、九，再加一對眼', isSelected: false, quantity: 1, image: '十六不搭.png' },
            { name: '嚦咕嚦咕', value: 40, desc: '八對子，三隻一樣的不能碰出', isSelected: false, quantity: 1, image: '嚦咕嚦咕.png' },
            { name: '一台花', value: 10, desc: '花牌達一台（指定數量）可加番，未達花胡', isSelected: false, quantity: 1, image: '一台花.png' },
            { name: '兩台花 (花胡)', value: 30, desc: '二台花可以立刻食胡, 不須要計手上的牌', isSelected: false, quantity: 1, image: '花胡.png' },
            { name: '七搶一', value: 20, desc: '自己有六隻花, 其中一家有一隻花, 自己摸最後一隻', isSelected: false, quantity: 1 },
            { name: '一搶七', value: 20, desc: '其中一家有七隻花, 自己摸最後一隻', isSelected: false, quantity: 1 },
            { name: '斷么', value: 5, desc: '全副牌沒有么九及番子', isSelected: false, quantity: 1 },
            { name: '全帶混么', value: 10, desc: '全副牌每一組合都有么九 or 番子', isSelected: false, quantity: 1, image: '全帶混么.png' },
            { name: '全帶么', value: 15, desc: '全副牌每一組合都有么九, 無 番子', isSelected: false, quantity: 1, image: '全帶么.png' },
            { name: '混么', value: 30, desc: '全副牌都是么九及番子', isSelected: false, quantity: 1, image: '混么.png' },
            { name: '清么', value: 80, desc: '全副牌都是么九', isSelected: false, quantity: 1, image: '清么.png' },
            { name: '天胡', value: 100, desc: '莊家一開牌補花後即吃糊 (開牌開槓後吃糊唔計天胡)', isSelected: false, quantity: 1 },
            { name: '地胡', value: 90, desc: '莊家打出第一隻牌出沖給其他家', isSelected: false, quantity: 1 },
            { name: '人胡', value: 80, desc: '不是莊家獨有的牌類，閒家在四隻牌內 吃糊', isSelected: false, quantity: 1 },
        ],
    },
];

import { reactive } from 'vue';

import {
    supabase,
    fetchGameProfiles,
    createSupabaseProfile,
    updateSupabaseProfile,
    deleteSupabaseProfile
} from '../services/SupabaseService';

// Helper to deep clone and reset selection
const resetGroups = (groups) => {
    const cloned = JSON.parse(JSON.stringify(groups));
    cloned.forEach(group => {
        group.options.forEach(option => {
            option.isSelected = false;
            option.quantity = 1;
        });
    });
    return cloned;
};

// Initial state setup
export const state = reactive({
    user: null,
    profiles: [],
    activeProfileId: 'default',
    isLoading: false,
    get activeProfile() {
        return this.profiles.find(p => p.id === this.activeProfileId) || this.profiles[0] || { id: 'default', name: '標準規則', groups: JSON.parse(JSON.stringify(defaultGroups)) };
    },
    get groups() {
        return this.activeProfile.groups;
    },
    get isSignedIn() {
        return !!this.user;
    }
});

let isInitializing = false;

/**
 * Initialize the state by checking auth and loading appropriate data
 * @param {Object} providedUser - Optional user object from auth event
 */
export const initScores = async (providedUser = undefined) => {
    if (isInitializing) return;
    isInitializing = true;
    state.isLoading = true;

    try {
        // 1. Get current user if not provided
        let user;
        if (providedUser === undefined) {
            const { data } = await supabase.auth.getUser();
            user = data?.user || null;
        } else {
            user = providedUser;
        }

        state.user = user;

        if (user) {
            // Authenticated: Fetch from Supabase
            try {
                const dbProfiles = await fetchGameProfiles(user.id);
                if (dbProfiles && dbProfiles.length > 0) {
                    state.profiles = dbProfiles.map((p) => ({
                        id: p.id,
                        name: p.name,
                        groups: p.groups,
                        updatedAt: p.updated_at,
                        isDefault: p.name === '標準規則' // Identify the default profile by its reserved name
                    }));
                } else {
                    // Ensure at least one standard profile exists for the user
                    const defaultP = await createSupabaseProfile(user.id, '標準規則', JSON.parse(JSON.stringify(defaultGroups)));
                    state.profiles = [{
                        id: defaultP.id,
                        name: defaultP.name,
                        groups: defaultP.groups,
                        updatedAt: defaultP.updated_at,
                        isDefault: true
                    }];
                }
                state.activeProfileId = state.profiles[0].id;
            } catch (e) {
                console.error('Failed to fetch profiles from Supabase', e);
            }
        } else {
            // Not Authenticated: Use default
            state.profiles = [{
                id: 'default',
                name: '標準規則',
                groups: JSON.parse(JSON.stringify(defaultGroups)),
                updatedAt: Date.now(),
                isDefault: true
            }];
            state.activeProfileId = 'default';
        }
    } catch (error) {
        console.error('initScores major error:', error);
    } finally {
        state.isLoading = false;
        isInitializing = false;
    }
};

// Listen for auth changes
supabase.auth.onAuthStateChange(async (event, session) => {
    if (event === 'SIGNED_IN' || event === 'INITIAL_SESSION') {
        if (session?.user) {
            await initScores(session.user);
        }
    } else if (event === 'SIGNED_OUT') {
        await initScores(null);
    }
});

export const saveScores = async () => {
    if (!state.activeProfile) return;

    state.activeProfile.updatedAt = Date.now();

    if (state.isSignedIn) {
        // Only cloud users get persistence
        try {
            await updateSupabaseProfile(
                state.activeProfile.id,
                state.activeProfile.name,
                state.activeProfile.groups
            );
        } catch (e) {
            console.error('Supabase update failed', e);
        }
    } else {
        // Guest user: Web/Native - No persistence as requested.
        // It stays in state (RAM) until refresh.
    }
};

export const switchProfile = (id) => {
    if (state.profiles.some(p => p.id === id)) {
        state.activeProfileId = id;
        state.activeProfile.groups = resetGroups(state.activeProfile.groups);
    }
};

export const resetToStandard = async () => {
    if (!state.activeProfile) return;

    state.activeProfile.groups = JSON.parse(JSON.stringify(defaultGroups));
    if (state.activeProfile.isDefault) {
        state.activeProfile.name = '標準規則';
    }

    await saveScores();
};

export const createProfile = async (name, baseGroups = defaultGroups) => {
    if (!state.isSignedIn) {
        alert('請先登入以建立多個規則');
        return;
    }

    try {
        const newDbProfile = await createSupabaseProfile(state.user.id, name, resetGroups(baseGroups));
        const newProfile = {
            id: newDbProfile.id,
            name: newDbProfile.name,
            groups: newDbProfile.groups,
            updatedAt: newDbProfile.updated_at
        };
        state.profiles.push(newProfile);
        state.activeProfileId = newProfile.id;
        return newProfile;
    } catch (e) {
        console.error('Failed to create profile', e);
        alert('建立失敗');
    }
};

export const deleteProfile = async (id) => {
    const profileToDelete = state.profiles.find(p => p.id === id);
    if (!profileToDelete || profileToDelete.isDefault || (state.isSignedIn && state.profiles.length <= 1)) {
        return alert('不能刪除此規則檔');
    }

    if (state.isSignedIn) {
        try {
            await deleteSupabaseProfile(id);
            const index = state.profiles.findIndex(p => p.id === id);
            if (index !== -1) {
                state.profiles.splice(index, 1);
                if (state.activeProfileId === id) {
                    state.activeProfileId = state.profiles[0].id;
                }
            }
        } catch (e) {
            console.error('Delete failed', e);
            alert('刪除失敗');
        }
    } else {
        // Guest mode usually only has one profile anyway
        alert('功能限登入用戶使用');
    }
};

export const importProfile = async (jsonString) => {
    if (!state.isSignedIn) {
        alert('請先登入以匯入規則');
        return false;
    }

    try {
        const profileData = JSON.parse(jsonString);
        if (!profileData.name || !profileData.groups) throw new Error('Invalid format');

        const newDbP = await createSupabaseProfile(state.user.id, profileData.name + ' (Imported)', profileData.groups);
        const newProfile = {
            id: newDbP.id,
            name: newDbP.name,
            groups: newDbP.groups,
            updatedAt: newDbP.updated_at
        };
        state.profiles.push(newProfile);
        state.activeProfileId = newProfile.id;
        return true;
    } catch (e) {
        console.error('Import failed', e);
        return false;
    }
};

/**
 * Import a profile from already-parsed share data (used by ShareImportPage).
 * @param {string} name
 * @param {Array} groups
 * @returns {boolean}
 */
export const importProfileFromShared = async (name, groups) => {
    if (!state.isSignedIn) {
        return false;
    }

    try {
        if (!name || !groups) throw new Error('Invalid format');

        const newDbP = await createSupabaseProfile(state.user.id, name, groups);
        const newProfile = {
            id: newDbP.id,
            name: newDbP.name,
            groups: newDbP.groups,
            updatedAt: newDbP.updated_at
        };
        state.profiles.push(newProfile);
        state.activeProfileId = newProfile.id;
        return true;
    } catch (e) {
        console.error('Import from shared failed', e);
        return false;
    }
};

// Start initialization
initScores();

export default {
    state,
    groups: state.groups,
    defaultGroups,
    saveScores,
    switchProfile,
    createProfile,
    deleteProfile,
    importProfile,
    initScores
};